import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

const IDENTITY_PROVIDERS_STALE_TIME_MS = 5 * 60 * 1000;

export function useGetIdentityProviders() {
  return useQuery({
    queryKey: usersQueryKeys.identityProviders(),
    queryFn: ({ signal }) => UsersService.getIdentityProviders({ signal }),
    staleTime: IDENTITY_PROVIDERS_STALE_TIME_MS,
  });
}
